export default __webpack_public_path__ + "static/media/03.0a8ef74b.jpg";